export default class PdfContentStreamOperator extends String {
  constructor(value: string) {
    super(value);
  }

  toString(): string {
    return `${this.valueOf()}`;
  }
}
